import React, { useState } from 'react';
import {
    Box,
    Paper,
    Tabs,
    Tab,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SyncIcon from '@mui/icons-material/Sync';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import MenuBookIcon from '@mui/icons-material/MenuBook';

import BiometricDashboard from './BiometricDashboard';
import AddDeviceWizard from './AddDeviceWizard';
import BiometricEmployeeMapping from './BiometricEmployeeMapping';
import BiometricSyncHistory from './BiometricSyncHistory';
import BiometricReconciliationPreview from './BiometricReconciliationPreview';
import BiometricIntegrationGuide from './BiometricIntegrationGuide';

const CARD_SX = {
    p: 0,
    borderRadius: '16px',
    bgcolor: '#fff',
    border: '1px solid #eef0f4',
    boxShadow: '0 4px 20px rgba(17,24,39,0.05)',
    overflow: 'hidden',
};

const BiometricMain = () => {
    const [currentTab, setCurrentTab] = useState(0);

    return (
        <Box sx={{ width: '100%' }}>
            {/* Top Navigation Tabs */}
            <Paper elevation={0} sx={{ ...CARD_SX, mb: 2.5 }}>
                <Tabs
                    value={currentTab}
                    onChange={(_, v) => setCurrentTab(v)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        px: 2,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: '0.9rem',
                            minHeight: 54,
                        },
                        '& .Mui-selected': { color: '#2563eb !important' },
                        '& .MuiTabs-indicator': { bgcolor: '#2563eb', height: 3 },
                    }}
                >
                    <Tab icon={<DashboardIcon />} iconPosition="start" label="Device Dashboard" />
                    <Tab icon={<AddCircleOutlineIcon />} iconPosition="start" label="Add Device Wizard" />
                    <Tab icon={<PeopleAltIcon />} iconPosition="start" label="Employee Mapping" />
                    <Tab icon={<SyncIcon />} iconPosition="start" label="Sync & Punches" />
                    <Tab icon={<CompareArrowsIcon />} iconPosition="start" label="Reconciliation Preview" />
                    <Tab icon={<MenuBookIcon />} iconPosition="start" label="Integration Guide" />
                </Tabs>
            </Paper>

            {/* Tab Views */}
            {currentTab === 0 && (
                <BiometricDashboard
                    onOpenWizard={() => setCurrentTab(1)}
                    onOpenGuide={() => setCurrentTab(5)}
                />
            )}
            {currentTab === 1 && (
                <AddDeviceWizard
                    onComplete={() => setCurrentTab(0)}
                    onCancel={() => setCurrentTab(0)}
                />
            )}
            {currentTab === 2 && <BiometricEmployeeMapping />}
            {currentTab === 3 && <BiometricSyncHistory />}
            {currentTab === 4 && <BiometricReconciliationPreview />}
            {currentTab === 5 && <BiometricIntegrationGuide />}
        </Box>
    );
};

export default BiometricMain;

